<template>
  <!-- 分页器 -->
  <div class="paginations">
    <div class="block"
          style="display:flex;">
      <el-pagination layout="slot">
        <div class="button"
              @click="handleCurrentChange(1)">首页</div>
      </el-pagination>
      <el-pagination background
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-size="parseInt(page)"
                      :pager-count="showNum"
                      layout="prev, pager, next, slot"
                      :total="totalPage"
                      prev-text="上一页"
                      next-text="下一页">
        <div class="button"
              @click="handleCurrentChange(endPage)">末页</div>
        <select v-model="page"
                class="pageSizes"
                @change="handleSizeChange">
          <option>5条/页</option>
          <option>10条/页</option>
          <option>15条/页</option>
          <option>20条/页</option>
          <option>25条/页</option>
          <option>30条/页</option>
          <option>40条/页</option>
          <option>50条/页</option>
          <option>100条/页</option>
          <option>500条/页</option>
          <option>1000条/页</option>
        </select>
      </el-pagination>
      <el-pagination layout="slot">
        <template>
          <span class="pagi">
            <span class="el-pagination__jump">
              <div class="el-input el-pagination__editor is-in-pagination">
                <input type="number"
                        v-model="currentPageNum"
                        @keyup.enter="handleCurrentChange('jump')"
                        autocomplete="off"
                        class="el-input__inner">
              </div>
            </span>
          </span>
        </template>
      </el-pagination>
      <el-pagination layout="slot">
        <div class="button jump"
              @click="handleCurrentChange('jump')">跳转</div>
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'paging',
  props: {
    pages: String,
    endPage:Number,
    currentPage:Number,
    totalPage:Number
  },
  data(){
    return{
      currentPageNum: 1,
      page:this.pages
    }
  },
  computed:{
    showNum(){
      return window.innerWidth>768 ? 7 : 5
    }
  },
  methods:{
    handleSizeChange () {
      this.$emit('handleSizeChange', parseInt(this.page));
    },
    handleCurrentChange (val) {
      if (val == 'jump') {
        if (parseInt(this.currentPageNum) <= this.endPage) {
          this.$emit('handleCurrentChange', parseInt(this.currentPageNum));
        }
      } else {
        this.$emit('handleCurrentChange', val);
      }
    },
  }
}
</script>
<style lang="scss" scoped>
/* 分页 */
.paginations {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button {
  padding: 4px 9px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 2px;
  color: #606266;
}
.pageSizes {
  padding: 0 5px;
  outline: none;
  background: none;
  min-width: 80px;
  color: #666;
  border: 1px solid #ddd;
  height: 28px;
  line-height: 28px;
  overflow: hidden;
  border-radius: 4px;
  margin-left: 5px;
}
</style>
<style>
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background-color: white !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409eff !important;
}
.el-pagination ul li {
  border: 1px solid #ddd !important;
}
.btn-prev,
.btn-next {
  margin: 0 !important;
  padding: 0 5px !important;
  border: 1px solid #ddd !important;
}
.btn-prev {
  margin-left: 6px !important;
}
.btn-next {
  margin-right: 6px !important;
}
.el-pagination {
  font-weight: 400 !important;
  padding: 0 !important;
  display: flex;
  height: 27px;
  cursor: pointer;
}

.el-pagination__jump {
  margin-left: 0 !important;
}
.el-pagination__sizes {
  margin: 0 !important;
}
.el-select-dropdown__item {
  height: auto !important;
  line-height: 19px !important;
}
.el-select-dropdown__item.selected {
  font-weight: 400 !important;
  background-color: #409eff;
  color: white;
}
@media screen   and (max-width: 420px) {
  .el-pagination.is-background .el-pager li{
    margin: 0 1px;
  }
  .el-pagination .jump{
    padding: 4px 2px;
  }
}
@media screen   and (max-width: 520px) {
  .paginations>div>div:first-child,.paginations .is-background .button{
    display:none;
  }
}
@media screen and (max-width: 600px) {
  .paginations .btn-prev,.paginations .btn-next{
    display:none;
  }
}
@media screen and (max-width: 670px) {
  .paginations .pageSizes{
    display:none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/paging.vue